import React, { useState } from "react";
import { Input, Form, Col, Row } from "reactstrap";
import CampaignsTable from "./CampaignsTable";

// Custom Hooks
import useTableController from "hooks/useTableController";

// Validation
import { SearchFilterSchema } from "model/_base/filters/filter-options.schema";

// API
import { useGetCampaignsQuery } from "services/campaigns/api";

const CampaignsTab = () => {
  const [campaigns, setCampaigns] = useState(null);

  // FORM - ใช้ useTableController แทน useFormik
  const { formik, searchInput, setSearchInput, handleTableChange } = useTableController({
    initialValues: {},
    validationSchema: SearchFilterSchema,
  });

  // API
  const { data, error, isLoading } = useGetCampaignsQuery(formik.values);

  React.useEffect(() => {
    if (data) {
      setCampaigns(data);
    }
  }, [data]);

  // ACTIONS
  const handleStatusChange = (id, value) => {
    if (!campaigns) return;
    const updatedItems = campaigns.data.map((item) => (item.id === id ? { ...item, isActive: value } : item));
    setCampaigns((prev) => ({
      ...prev,
      data: updatedItems,
    }));
  };

  // RENDER
  return (
    <Form className="form-horizontal w-100 d-flex flex-column gap-4" onSubmit={formik.handleSubmit} data-testid="search-form">
      <div className="campaigns-tab" data-testid="tab-campaigns">
        <div className="header">
          <h2 className="fw-semibold">แคมเปญที่มีอยู่</h2>
          <div className="d-flex flex-column gap-2">
            <Row className="gy-3">
              <Col sm={12} md={4} lg={4}>
                <div className="input-group-icon">
                  <i className="bx bx-search" />
                  <Input name="searchTerm" type="text" placeholder="ค้นหารายการแคมเปญ" onChange={(e) => setSearchInput(e.target.value)} value={searchInput} data-testid="search-input" invalid={formik.touched.searchTerm && formik.errors.searchTerm} />
                  {formik.touched.searchTerm && formik.errors.searchTerm && (
                    <div className="error-message" data-testid="search-error">
                      {formik.errors.searchTerm}
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </div>

        <CampaignsTable data={campaigns} error={error} isLoading={isLoading} onStatusChange={handleStatusChange} onTableChange={handleTableChange} />
      </div>
    </Form>
  );
};

export default CampaignsTab;
